import { render, staticRenderFns } from "./FormConfiguracion.vue?vue&type=template&id=16746439&scoped=true"
import script from "./FormConfiguracion.vue?vue&type=script&lang=js"
export * from "./FormConfiguracion.vue?vue&type=script&lang=js"
import style0 from "./FormConfiguracion.vue?vue&type=style&index=0&id=16746439&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16746439",
  null
  
)

export default component.exports